import React, { useState, useEffect } from "react";
import validator from "validator";
import axios from "axios";
import { useAuth } from "../contexts/auth";
import { postUpdateClerkURL, postUpdatePersonnelURL } from "../utils/api";
import {
    Flex,
    Spacer,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
    Input,
    Text,
    RadioGroup,
    Radio,
    HStack,
    Box,
    InputRightElement,
  } from "@chakra-ui/react";

function EditPersonnel({
    isOpen,
    onClose,
    successCallback,
    userData,
    isToolsClerk = false
}) {

    const [ firstName, setFirstName ] = useState('');
    const [ lastName, setLastName ] = useState('');
    const [ gender, setGender ] = useState('Male');
    const [ email, setEmail ] = useState('');

    const [ invFirstName, setInvFirstName ] = useState(null);
    const [ invLastName, setInvLastName ] = useState(null);
    const [ invEmail, setInvEmail ] = useState(null);

    const { auth } = useAuth();
    const [ errors, setErrors ] = useState([]);
    const [ submitting, setSubmitting ] = useState(false);

    const postPersonnels = (e) => {
        e.preventDefault();

        let id;
        if (userData) {
            id = userData.id;
        } 

        setSubmitting(true);
        // console.log(email, password);
        axios.post(!isToolsClerk 
            ? postUpdatePersonnelURL(id)
            : postUpdateClerkURL(id), 
        {
            email,
            firstName,
            lastName,
            gender,
        },{
            headers: {
                Authorization: `Bearer ${auth.authToken}`
            }
        }).then(result => {
            if (result.status === 200) {
                // const roles = result.data.data.user.roles;
                const user = result.data.data;
                // console.log(user);
                if (successCallback) {
                    successCallback();
                }
                onClose();
            } else {
                setErrors(result.data.errors);
            }
        }).catch(e => {
            if (e.response === undefined) {
                setErrors(['Could not connect to server!'])
            } else {
                setErrors(e.response.data.errors)
            }
        }).finally(e => {
            setSubmitting(false);
        });
    }

    useEffect(() => {

        if (!validator.isEmpty(email)) {
            setInvEmail(!validator.isEmail(email));
        }

        if (!validator.isEmpty(firstName)) {
            setInvFirstName(firstName.length < 1);
        }

        if (!validator.isEmpty(lastName)) {
            setInvLastName(lastName.length < 1);
        }

    }, [firstName, lastName, email]);

    useEffect(() => {
        // console.log(userData);

        if (userData) {
            setFirstName(userData.firstName);
            setLastName(userData.lastName);
            setEmail(userData.email);
            setGender(userData.gender);
        }

    }, [userData]);

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
            <ModalHeader>Edit {!isToolsClerk 
                ? 'Inventory Personnel'
                : 'Tools Clerk'
             } Account</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
                <form onSubmit={postPersonnels}>
                    <FormControl >
                    <Flex w="100%"
                        flexDirection={{
                        sm: "row",
                        md: "row",
                        }} 
                        alignItems={{ xl: "center" }}>
                        
                        <Box pr="12px">
                            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                First Name
                            </FormLabel>
                            <Input
                                borderRadius="15px"
                                mb="12px"
                                fontSize="sm"
                                type="text"
                                placeholder="First Name"
                                size="md" 
                                isInvalid={invFirstName === true}
                                isRequired={true}
                                value={firstName} 
                                onChange={e => setFirstName(e.target.value)}
                            />
                        </Box>

                         
                        <Box pr="12px">
                            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                Last Name
                            </FormLabel>
                            <Input
                                borderRadius="15px"
                                mb="12px"
                                fontSize="sm"
                                type="text"
                                placeholder="Last Name"
                                size="md" 
                                isInvalid={invLastName === true}
                                isRequired={true}
                                value={lastName} 
                                onChange={e => setLastName(e.target.value)}
                            />
                        </Box>

                    </Flex>

                    <FormLabel as="legend">Gender</FormLabel>
                    <RadioGroup 
                        defaultValue="Male" mb="12px" 
                        onChange={setGender}
                        value={gender}
                    >
                        <HStack spacing="24px">
                            <Radio value="Male">Male</Radio>
                            <Radio value="Female">Female</Radio>
                            {/* <Radio value="Other">Other</Radio> */}
                        </HStack>
                    </RadioGroup>
                    
                    <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                        Email
                    </FormLabel>
                    <Input
                        borderRadius="15px"
                        mb="36px"
                        fontSize="sm"
                        type="text"
                        placeholder="Enter Email Address"
                        size="md" 
                        isInvalid={invEmail === true}
                        isRequired={true}
                        value={email} 
                        onChange={e => setEmail(e.target.value)}
                    />
                

                    <Flex w="100%" flexDir="column">
                        { errors.length > 0 && <Text color="red">{errors[0]}</Text> }
                    </Flex>
                    <Button
                        fontSize="10px"
                        type="submit"
                        bg="teal.300"
                        w="100%"
                        h="45"
                        mb="20px"
                        color="white"
                        mt="0px"
                        _hover={{
                        bg: "teal.200",
                        }}
                        _active={{
                        bg: "teal.400",
                        }}
                        isDisabled={submitting}
                    >
                        SAVE
                    </Button>
                </FormControl>
            </form>
            </ModalBody>
            {/* <ModalFooter>
                <Flex w="100%"
                flexDirection={{
                sm: "row",
                md: "row",
                }} 
                alignItems={{ xl: "center" }}>
                <Button variant="ghost" onClick={onClose}>Cancel</Button>
                <Spacer />
                <Button colorScheme="teal" mr={3} >
                    Submit
                </Button>
                </Flex>
            </ModalFooter> */}
            </ModalContent>
        </Modal>
    );

}



export default EditPersonnel;
